import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checked",
  "use": "icon-checked-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" class=\"design-iconfont\" id=\"icon-checked\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#F65A3D\" d=\"M10 0A10 10 0 1 0 10 20A10 10 0 1 0 10 0Z\" />\n    <path stroke=\"#FFF\" stroke-width=\"2\" stroke-linejoin=\"round\" d=\"M5.74256944 9.5L9 12.7574306 14.2574306 7.5\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol